<h3>{{ message.header }}</h3>
<div>
  <a [routerLink]="['/plants', message.plant.id]"><img [src]="message.plant.thumbnail" [alt]="message.plant.name"/></a>
  <p [routerLink]="['/plants', message.plant.id]">
    {{ message.text | translate: message.textParams }} <mat-icon [inline]="true">play_arrow</mat-icon>
  </p>
</div>

